import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import { TopOffendersAggSubRegionReportRequest } from '../requests/TopOffendersAggSubRegionRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const TopOffendersAggSubRegionExport = (values, userId) => async (dispatch) => {
	await TopOffendersAggSubRegionReportRequest(values, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
